import React, { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Constants */
import { env } from "../constants"


/* Video */
class Video extends Component {

    constructor() {
        super()

        this.state = {
            scale: 1,
            offsetX: 0,
            offsetY: 0,
            visible: false,
            data: null,
            playbackRate: 1
        }
    }

    /* Open */
    open = data => {
        this.setState({ visible: true, data })
    }

    /* Close */
    close = () => {
        this.setState({ visible: false, data: null })
    }

    setPlaybackRate = (rate = 1) => {
        this.setState({ playbackRate: rate }, () => {
            if (this._video) {
                this._video.playbackRate = rate
            }
        })
    }

    updateTransform = () => {

        const { scale, offsetX, offsetY } = this.state

        if (this._video) {
            this._video.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${scale})`
        }
    }

    // ----- ZOOM -----

    zoomIn = () => {
        this.setState({ scale: this.state.scale + 0.2 }, this.updateTransform)
    }

    zoomOut = () => {
        this.setState({ scale: Math.max(1, this.state.scale - 0.2) }, this.updateTransform)
    }

    moveUp = () => {
        this.setState(
            prev => ({ offsetY: prev.offsetY - 20 }),
            this.updateTransform
        )
    }

    moveDown = () => {
        this.setState(
            prev => ({ offsetY: prev.offsetY + 20 }),
            this.updateTransform
        )
    }

    moveLeft = () => {
        this.setState(
            prev => ({ offsetX: prev.offsetX - 20 }),
            this.updateTransform
        )
    }

    moveRight = () => {
        this.setState(
            prev => ({ offsetX: prev.offsetX + 20 }),
            this.updateTransform
        )
    }

    render = () => {

        /* Fields */
        const { visible, data, scale } = this.state

        /* Check */
        if (!data) {
            return null
        }

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="video-modal"
                overlayClassName="video-overlay"
                closeTimeoutMS={200}
            >

                {/* Draw Header */}
                <div className="video-header">

                    <h2>Video</h2>

                    <div className="video-header-panels">

                        <div className="video-header-zoom-buttons">
                            <div onClick={() => this.zoomOut()} className="video-header-zoom">
                                <img src="/images/zoom-out.png" alt="zoom-in" />
                            </div>
                            <div className="video-header-zoom-value">{parseFloat(scale).toFixed(1)}</div>
                            <div onClick={() => this.zoomIn()} className="video-header-zoom">
                                <img src="/images/zoom-in.png" alt="zoom-out" />
                            </div>
                        </div>

                    </div>

                    <div className="video-header-buttons">
                        <button onClick={this.moveUp}>↑</button>
                        <button onClick={this.moveLeft}>←</button>
                        <button onClick={this.moveRight}>→</button>
                        <button onClick={this.moveDown}>↓</button>
                    </div>

                    <div className="video-header-paybacks">
                        <button onClick={() => this.setPlaybackRate(0.25)}>0.25x</button>
                        <button onClick={() => this.setPlaybackRate(0.5)}>0.5x</button>
                        <button onClick={() => this.setPlaybackRate(1)}>1x</button>
                        <button onClick={() => this.setPlaybackRate(2)}>2x</button>
                        <button onClick={() => this.setPlaybackRate(3)}>3x</button>
                    </div>

                    <div className="video-header-reset">
                        <button onClick={() => this.setState({ scale: 1, offsetX: 0, offsetY: 0 }, () => {
                            this.setPlaybackRate(1)
                            this.updateTransform()
                        })}>Сбросить</button>
                    </div>

                    <div onClick={() => this.close()} className="video-close">
                        <img src="/images/close.png" alt="Close" />
                    </div>
                </div>

                <div className="video-content">
                    <video ref={ref => this._video = ref} src={`${env.point}${data.link}`} controls id="video" />
                </div>

            </Modal>
        )
    }
}

export default Video